import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Вставляем полный код SVG логотипа
const generateReceiptHTML = (order) => {
    const formattedDate = order.date ?
        `${order.date.split('-')[2]}.${order.date.split('-')[1]}.${order.date.split('-')[0]}` :
        'Не указана';

    return `
    <div style="
      font-family: Arial, sans-serif; 
      margin: auto;
      width: 300px;
      padding: 20px; 
      background: white;
      font-size: 11px;
      line-height: 1.4;
      border:0.4px solid #669;
    ">

    


      <!-- Заголовок -->
      <div style="text-align: center; margin-bottom: 15px;">
        <div style="color: #333333; font-size: 18px; font-weight: bold; margin-bottom: 5px;">
          <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 57.26 9.04" style="height: 25px; width: auto; vertical-align: middle; margin-right: 8px;">
            <style type="text/css">
              .st0{fill:#333333;}
            </style>
            <g>
	<g>
		<path class="st0" d="M0,8.13C0.05,7.72,0.1,7.3,0.14,6.89c0.16-1.7,0.31-3.41,0.47-5.11c0.03-0.37,0.06-0.74,0.1-1.11
			C0.76,0.28,1.05,0.05,1.42,0.1c0.12,0.02,0.24,0.08,0.33,0.16c1.24,1.26,2.46,2.53,3.7,3.8c0.25,0.26,0.53,0.5,0.82,0.78
			C6.5,4.63,6.77,4.39,7.04,4.15c1.46-1.31,2.91-2.61,4.37-3.92c0.26-0.24,0.5-0.29,0.75-0.17c0.31,0.15,0.39,0.34,0.36,0.74
			c-0.15,1.66-0.3,3.31-0.44,4.97c-0.08,0.85-0.15,1.7-0.24,2.55c-0.03,0.28-0.18,0.5-0.46,0.61c-0.25,0.1-0.52,0.11-0.71-0.1
			c-0.12-0.13-0.23-0.33-0.22-0.49c0.14-1.75,0.31-3.5,0.48-5.25c0.02-0.23,0.04-0.45,0.06-0.73c-0.41,0.36-0.78,0.68-1.15,1.01
			C8.71,4.37,7.58,5.36,6.45,6.36C6.19,6.59,6.05,6.59,5.8,6.34C4.55,5.08,3.3,3.81,2.06,2.55C2.02,2.51,1.98,2.48,1.9,2.41
			c-0.03,0.32-0.07,0.6-0.09,0.88c-0.15,1.66-0.3,3.33-0.44,4.99C1.34,8.59,1.19,8.81,0.92,8.93C0.68,9.04,0.41,9.04,0.19,8.84
			C0.12,8.77,0.06,8.68,0,8.61C0,8.45,0,8.29,0,8.13z"/>
		<path class="st0" d="M25.75,8.85c-0.96,0-1.92,0-2.88,0c-0.05,0-0.1,0-0.14,0c-0.37-0.02-0.56-0.17-0.56-0.47
			c0-0.29,0.25-0.54,0.57-0.56c0.35-0.01,0.7-0.01,1.05-0.01c1.65,0,3.3,0.01,4.95,0.01c0.79,0,1.29-0.56,1.2-1.34
			c-0.04-0.4-0.46-0.72-0.96-0.72c-1.62,0-3.23,0-4.85,0c-0.59,0-1.11-0.19-1.54-0.58c-0.33-0.3-0.49-0.68-0.44-1.13
			c0.15-1.3,0.98-2.03,2.32-2.03c1.93-0.01,3.85,0,5.78,0c0.39,0,0.57,0.14,0.58,0.44c0.01,0.31-0.25,0.57-0.6,0.58
			c-0.35,0.01-0.7,0.01-1.05,0.01c-1.59,0-3.19-0.01-4.78,0c-0.23,0-0.47,0.06-0.68,0.15c-0.4,0.17-0.6,0.57-0.52,0.94
			c0.06,0.3,0.4,0.55,0.81,0.58c0.09,0.01,0.19,0.01,0.29,0.01c1.59,0,3.19,0,4.78,0c0.75,0,1.74,0.51,1.9,1.51
			c0.18,1.14-0.49,2.19-1.65,2.51c-0.25,0.07-0.51,0.1-0.77,0.1C27.62,8.86,26.68,8.85,25.75,8.85C25.75,8.85,25.75,8.85,25.75,8.85
			z"/>
		<path class="st0" d="M35.57,8.85c-0.82,0-1.63,0-2.45,0c-0.54,0-1.02-0.18-1.44-0.54c-0.38-0.34-0.57-0.76-0.53-1.27
			c0.08-1.02,0.18-2.04,0.27-3.05c0.04-0.48,0.08-0.96,0.13-1.44c0.03-0.31,0.28-0.54,0.59-0.54c0.26,0,0.47,0.22,0.45,0.5
			c-0.08,0.99-0.18,1.97-0.27,2.96c-0.04,0.44-0.09,0.88-0.12,1.33c-0.04,0.64,0.32,1.01,0.97,1.01c0.94,0,1.89,0,2.83,0
			c0.71,0,1.43,0,2.14,0c0.53,0,1-0.42,1.05-0.94c0.12-1.28,0.23-2.56,0.34-3.83c0.02-0.17,0.03-0.35,0.05-0.52
			c0.04-0.32,0.34-0.54,0.67-0.5c0.29,0.04,0.43,0.27,0.4,0.62c-0.12,1.32-0.26,2.63-0.35,3.95c-0.1,1.34-1.05,2.26-2.39,2.26
			C37.12,8.85,36.35,8.85,35.57,8.85z"/>
		<path class="st0" d="M50.19,3.7c1.53,0,3.06,0.01,4.59-0.01c0.49,0,0.78,0.28,0.77,0.62c-0.01,0.39-0.28,0.65-0.75,0.72
			c-0.06,0.01-0.13,0-0.19,0c-2.75,0-5.5,0-8.25,0c-0.23,0-0.32,0.04-0.34,0.3c-0.07,1.04-0.18,2.08-0.27,3.12
			c-0.03,0.32-0.44,0.63-0.8,0.59c-0.37-0.03-0.57-0.3-0.53-0.7c0.12-1.32,0.23-2.63,0.35-3.95c0.04-0.45,0.29-0.7,0.76-0.7
			C47.08,3.69,48.64,3.7,50.19,3.7z"/>
		<path class="st0" d="M51.02,0.17c1.73,0,3.45,0,5.18,0c0.46,0,0.69,0.2,0.72,0.61c0.02,0.32-0.31,0.66-0.68,0.7
			c-0.04,0-0.08,0-0.12,0c-3.45,0-6.89,0.01-10.34-0.01c-0.58,0-0.75-0.31-0.68-0.77c0.06-0.36,0.33-0.54,0.75-0.54
			C47.58,0.17,49.3,0.17,51.02,0.17z"/>
		<path class="st0" d="M18.54,3.12c-0.05,0.52-0.09,1-0.13,1.49c-0.11,1.29-0.22,2.57-0.34,3.86c-0.02,0.27-0.3,0.48-0.57,0.46
			c-0.26-0.02-0.45-0.23-0.42-0.53c0.08-1,0.17-2,0.26-3.01c0.07-0.75,0.13-1.5,0.2-2.28c-0.11,0-0.21,0-0.3,0
			c-0.98,0-1.97,0-2.95,0c-0.33,0-0.58-0.18-0.58-0.43c0-0.32,0.25-0.59,0.58-0.59c2.55,0,5.1,0,7.66,0c0.33,0,0.5,0.17,0.51,0.47
			c0.01,0.3-0.23,0.55-0.56,0.55c-0.57,0.01-1.14,0-1.71,0C19.65,3.12,19.11,3.12,18.54,3.12z"/>
		<path class="st0" d="M12.13,8.38c0.1-1.17,0.21-2.33,0.31-3.5c0.07-0.75,0.13-1.5,0.2-2.25c0.03-0.34,0.29-0.56,0.58-0.52
			c0.29,0.03,0.44,0.29,0.41,0.64c-0.11,1.17-0.21,2.35-0.32,3.52c-0.07,0.73-0.13,1.47-0.19,2.2c-0.02,0.26-0.31,0.49-0.57,0.46
			C12.27,8.91,12.12,8.71,12.13,8.38z"/>
	</g>
</g>
          </svg>
        </div>
        <div style="font-size: 14px; font-weight: bold; margin: 5px 0;">Чек по операции</div>
        <div style="font-size: 11px; color: #666; margin-bottom: 8px;">${formattedDate}</div>
        <div style="border-bottom: 1px dashed #ccc; margin: 10px 0;"></div>
      </div>
      
      <!-- Информация об операции -->
      <div style="margin-bottom: 15px;">
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Операция</div>
        <div style="font-weight: bold; margin-bottom: 10px;">Продажа товара</div>
        
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Номер заказа</div>
        <div style="font-weight: bold; margin-bottom: 10px;">${order.number}</div>
        
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Товар</div>
        <div style="font-weight: bold; margin-bottom: 10px;">${order.name || 'Не указан'}</div>

        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Код</div>
        <div style="font-weight: bold; margin-bottom: 10px;">${order.sku || 'Не указан'}</div>
        
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Количество</div>
        <div style="font-weight: bold; margin-bottom: 10px;">${order.quantity || 1} шт.</div>
        
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Сумма операции</div>
        <div style="font-weight: bold; font-size: 16px; margin-bottom: 5px;">${order.total || 0},00 ₽</div>
        ${order.jpy_total ? `<div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Цена в йенах: ${order.jpy_total}¥</div>` : ''}
        
        <div style="color: #666; font-size: 10px; margin-bottom: 3px;">Номер документа</div>
        <div style="font-weight: bold; margin-bottom: 10px;">${Math.floor(Math.random() * 100000000000000000).toString()}</div>
      </div>
      
      <div style="border-bottom: 1px dashed #ccc; margin: 15px 0;"></div>
      
      <!-- Печать -->
      <div style="text-align: center; margin: 15px 0;">
        <img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIf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" style="width: 80px; height: auto; opacity: 0.7;" alt="Печать">
      </div>

      <div style="border-bottom: 1px dashed #ccc; margin: 15px 0;"></div>
      
      <!-- Благодарность и сайт -->
      <div style="text-align: center; margin: 15px 0; color: #666;">
        <div style="font-size: 14px; font-weight: bold; margin-bottom: 8px; color: #333;">Спасибо за покупку!</div>
        <div style="font-size: 12px;">mitsuefu.com</div>
        <div style="font-size: 10px; margin-top: 5px;">+ 8190-4597-9795 | mitsuefu@gmail.com</div>
      </div>  
    </div>
  `;
};

// Функция для генерации и открытия PDF
export const generateReceiptPDF = async (order) => {
    try {
        // Создаем временный div для рендеринга HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = generateReceiptHTML(order);
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '-9999px';
        document.body.appendChild(tempDiv);

        // Ждем немного для полной загрузки
        await new Promise(resolve => setTimeout(resolve, 200));

        // Конвертируем HTML в canvas
        const canvas = await html2canvas(tempDiv, {
            scale: 1.5,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            width: 400,
            logging: false
        });

        // Удаляем временный div
        document.body.removeChild(tempDiv);

        // Создаем PDF
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        // Рассчитываем размеры для вставки изображения (компактно)
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Устанавливаем ширину чека как 60% от ширины страницы для компактности
        const imgWidth = pdfWidth * 0.6;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Располагаем чек в левом верхнем углу с отступом
        const xPosition = 20; // Отступ слева 20mm
        const yPosition = 20; // Отступ сверху 20mm

        // Проверяем, помещается ли чек на одну страницу
        if (imgHeight <= pdfHeight - 40) { // 40mm запас сверху и снизу
            // Добавляем изображение на страницу
            pdf.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
        } else {
            // Если не помещается, масштабируем
            const scaledHeight = pdfHeight - 40;
            const scaledWidth = (canvas.width * scaledHeight) / canvas.height;

            pdf.addImage(imgData, 'PNG', xPosition, yPosition, scaledWidth, scaledHeight);
        }

        // Создаем имя файла с номером заказа и датой
        const filename = `receipt_${order.number || 'unknown'}_${new Date().toISOString().split('T')[0]}.pdf`;
        
        // Создаем blob для PDF
        const pdfBlob = pdf.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        
        // Открываем новую вкладку
        const newTab = window.open('', '_blank');
        
        if (newTab) {
            // Создаем HTML для новой вкладки с автоматическим скачиванием
            newTab.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Скачивание чека...</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100vh;
                            margin: 0;
                            background-color: #f5f5f5;
                        }
                        .message {
                            text-align: center;
                            padding: 20px;
                            background: white;
                            border-radius: 8px;
                            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        }
                    </style>
                </head>
                <body>
                    <div class="message">
                        <h2>Скачивание чека...</h2>
                        <p>Файл "${filename}" будет скачан автоматически</p>
                        <p>Эта вкладка закроется через несколько секунд</p>
                    </div>
                    <script>
                        // Создаем ссылку для скачивания
                        const link = document.createElement('a');
                        link.href = '${pdfUrl}';
                        link.download = '${filename}';
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        
                        // Автоматически скачиваем файл
                        link.click();
                        
                        // Закрываем вкладку через 3 секунды
                        setTimeout(() => {
                            window.close();
                        }, 3000);
                        
                        // Очищаем URL
                        setTimeout(() => {
                            URL.revokeObjectURL('${pdfUrl}');
                        }, 5000);
                    </script>
                </body>
                </html>
            `);
            newTab.document.close();
        } else {
            // Если не удалось открыть новую вкладку, используем прямое скачивание
            pdf.save(filename);
        }

    } catch (error) {
        console.error('Ошибка при генерации PDF:', error);
        alert('Произошла ошибка при генерации чека. Попробуйте еще раз.');
    }
};
